import { useQuery } from '@tanstack/react-query';

import { Fonts } from '@air/api';
import { callAirApi } from '@air/utils-api';

const PRIVATE_FONTS_LIST_KEY = 'PRIVATE_FONTS_LIST';

export type PrivateFontsListParams = NonNullable<Parameters<typeof Fonts.list>[0]>;

export const getPrivateFontsListKey = (params: PrivateFontsListParams) => {
  return [PRIVATE_FONTS_LIST_KEY, params];
};

export type UsePrivateFontsListOptions = {
  enabled?: boolean;
};

export const usePrivateFontsList = (params: PrivateFontsListParams, options?: UsePrivateFontsListOptions) => {
  return useQuery({
    enabled: options?.enabled,
    queryFn: () => callAirApi(() => Fonts.list(params)),
    queryKey: getPrivateFontsListKey(params),
    staleTime: Infinity,
  });
};
